export default "__VITE_ASSET__Dn4j_X8w__"